export default __webpack_public_path__ + "static/comparisons-eda-a09de167e7247b30c5223e18453b3880.png";